import React, { useState, useEffect, use } from   'react';
import { useForm } from 'react-hook-form';
import { Form, Row, Col, FormGroup, Card, ButtonGroup, Button } from 'react-bootstrap';
import CargandoSpinner from '../Utils/CargandoSpinner';
import apiService from '../../Auth/apiService';
import { useAuth } from '../../Auth/AuthContext';
import SweetAlert2 from 'react-sweetalert2';

export default function FormularioLineasPE() {
    const { token, rol } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    const [lineasPE, setLineasPE] = useState([]);
    const defaultValues = {
        id: 0,
    };
    const { watch, handleSubmit, register, setValue, getValues, reset, trigger, control, formState: { errors }} = useForm({ 
                defaultValues: defaultValues
            }
        );
    async function obtenerLineasPE() {
        setCargando(true);
        try {
            const response = await apiService.get('/encuestassv/reportes/obtenerlineaspe', token);
            setLineasPE(response.data);
        } catch (error) {
            console.error('Error al obtener las líneas de pobreza y pobreza extrema:', error);
        } finally {
            setCargando(false);
        }
    }
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    useEffect(() => {
        obtenerLineasPE();
    }, []);
    async function GuardarDatosLPE(data) {
        setCargando(true);
        
        const payload = {
            id: Number(data.id) || 0,
            anio: Number(data.str_anio),
            valorLP: Number(data.str_lp),
            valorLPE: Number(data.str_lpe)
        };
        const url = '/encuestassv/reportes/guardarlplpe';
        await apiService.post(url, payload, token)
        .then(response => {
            if (response.data.success) {    
                Mensaje('Éxito', response.data.message);
                obtenerLineasPE();
                reset(defaultValues);
            } else {
                Mensaje('Error', response.data.message);
            }
        })
        .catch(error => {
            console.error('Error al guardar los datos de LPE:', error);
            Mensaje('Error', 'Ocurrió un error al guardar los datos. Por favor, inténtalo de nuevo.' + (error.response?.data?.message || ''));

        })
        .finally(() => {
            setCargando(false);
        });
    }
    return (
        <Card>
            <Card.Header style={{backgroundColor: '#3c8dbc', color: 'white'}}>
                <h3>Fuerza de Trabajo<sup style={{fontSize: '20px'}}></sup></h3>
                <p>Definir valores para: Linea de Pobreza y Linea de Pobreza Extrema</p>
            </Card.Header>
            <Card.Body>
                <CargandoSpinner Cargando={Cargando} />
                <div  id="divformregistro">
                    <h3 className="box-title">Registos Linea de Pobreza - Linea de Pobreza Extrema</h3>
                    {lineasPE.length > 0 ? (
                        <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>id</th>
                                    <th>Año</th>
                                    <th>Valor Linea de Pobreza</th>
                                    <th>Valor Linea de Pobreza Extrema</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {lineasPE.map((linea) => (
                                    <tr key={linea.id}>
                                        <td>{linea.id}</td>
                                        <td>{linea.str_anio}</td>
                                        <td>{linea.str_lp}</td>
                                        <td>{linea.str_lpe}</td>
                                        <td>
                                            <button 
                                                type="button"
                                                className="btn btn-sm btn-warning"
                                                onClick={() => {
                                                    setValue('id', linea.id);
                                                    setValue('str_anio', linea.str_anio);
                                                    setValue('str_lp', linea.str_lp);
                                                    setValue('str_lpe', linea.str_lpe);
                                                }}
                                            >
                                                Editar
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        </div>
                    ) : (
                        <p>No hay registros disponibles.</p>
                    )}
                    <Form onSubmit={handleSubmit(GuardarDatosLPE)}>
                        <Row>
                            <Col md={2}>
                                <FormGroup>
                                    <Form.Label htmlFor="id">id</Form.Label>
                                    <Form.Control readOnly className="form-control" id="id" placeholder="id" type="text" {...register('id')}>
                                    </Form.Control>
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup>
                                    <Form.Label htmlFor="str_anio">Año</Form.Label>
                                    <Form.Control className="form-control" id="str_anio" placeholder="Año" type="text" {...register('str_anio')}>
                                    </Form.Control>
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Form.Label htmlFor="str_lp">Valor Linea de Pobreza</Form.Label>
                                    <Form.Control className="form-control" id="str_lp" type="text" {...register('str_lp')}>
                                    </Form.Control>
                                </FormGroup>  
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Form.Label htmlFor="str_lpe">Valor Linea de Pobreza Extrema</Form.Label>
                                    <Form.Control className="form-control" id="str_lpe" type="text" {...register('str_lpe')}>
                                    </Form.Control>
                                </FormGroup>  
                            </Col>
                        </Row>
                        <hr />
                        <Row>
                            <Col md={12}>
                            <ButtonGroup>
                                {getValues('id') == 0 ? <Button type='button' id="btnlplpeadd" className="btn btn-primary" >Registrar!</Button> : null}
                                {getValues('id') == 0 ? null : <Button type='button' id="btnlplpeupdate" className="btn btn-primary" >Actualizar!</Button>}
                                {getValues('id') == 0 ? null : <Button type='button' id="btnlplpeclear" className="btn btn-primary" 
                                    onClick={() => {
                                        reset(defaultValues);
                                    }}
                                    >Limpiar</Button>
                                }
                                {getValues('id') == 0 ? null : <Button type='button' id="btnlplpedelete" className="btn btn-primary" >Borrar!</Button>}
                            </ButtonGroup>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </Card.Body>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
        </Card>        
    );
}